import { AXIOS_API_INSTANCE } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"

export const changePaymentAmount = (setPaymentAmount, amount) => (e) => {
    if (e.target.value === '-' || e.target.value === '0-') {
        setPaymentAmount('-')
    } else if (e.target.value === '') {
        setPaymentAmount(0)
    } else if (e.target.value.match(/^-?\d+(\.\d{0,2})?$/)) { // TODO: USE PARSE MONEY INPUT FROM UTILS?
        if (e.target.value.match(/^-?\d+\.$/)) {
            setPaymentAmount(e.target.value)
        } else {
            if (amount >= 0) {
                setPaymentAmount(Math.min(Math.max(0, Math.round(parseFloat(e.target.value) * 100) / 100), amount))
            } else {
                setPaymentAmount(Math.max(Math.min(0, Math.round(parseFloat(e.target.value) * 100) / 100), amount))
            }
        }
    }
}

export const sendPayment = (setCheckoutPayingStep, enqueueSnackbar, closeModal) => (payment_type, invoice_id, payment_amount, selected_location_id, { description = undefined, email = undefined, selected_terminal = undefined } = {}) => {
    setCheckoutPayingStep(1)
    const payment_object = {
        invoice_id: invoice_id,
        payment_type: payment_type,
        payment_amount: payment_amount,
        selected_location: selected_location_id,
        description: description,
        email: email,
        selected_terminal: selected_terminal
    }
    send_authorized_request(() =>
        AXIOS_API_INSTANCE.put(`invoicepayments`, payment_object).then(() => {
            setCheckoutPayingStep(0)
            enqueueSnackbar('Successfully submitted payment', { variant: 'success' })
            closeModal(true)
        }).catch((error) => {
            setCheckoutPayingStep(0)
            enqueueSnackbar(`Failed to submit payment <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
        })
    )
}